import { createSlice } from "@reduxjs/toolkit";

export const widgetSlice = createSlice({
  name: "widget",
  initialState: {
    getWidgetResult: false,
    getWidgetLoading: false,
    getWidgetError: false,
    addWidgetResult: false,
    addWidgetLoading: false,
    deleteWidgetResult: false,
  },
  reducers: {
    widgetReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_WIDGET":
          return {
            ...state,
            getWidgetResult: payload.data,
            getWidgetLoading: payload.loading,
            getWidgetError: payload.error,
          };
        case "ADD_WIDGET":
          return {
            ...state,
            addWidgetResult: payload.data,
            addWidgetLoading: payload.loading,
          };
        case "DELETE_WIDGET":
          return {
            ...state,
            deleteWidgetResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { widgetReducers } = widgetSlice.actions;

export default widgetSlice.reducer;
